import { __decorate, __metadata } from "tslib";
import { LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';
import { VendorExposeGroup } from '../interface';
import { PatchBaseMetadataDto } from './PatchBaseMetadataDto';
export class PatchGoParrotMetadataDto extends PatchBaseMetadataDto {
    constructor() {
        super(...arguments);
        this.reason = 'Testing store';
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Reason', default: 'Testing store' }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(5, 250, { always: true }),
    Expose({ groups: [VendorExposeGroup.FIXTURE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.CREATE, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", String)
], PatchGoParrotMetadataDto.prototype, "reason", void 0);
//# sourceMappingURL=PatchGoParrotMetadataDto.js.map